import { createPrefixer } from '.'

const ROOT = 'ver-compras' as const
export const RESOURCE_COMPRAS = 'Compras' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pt = createPrefixer(ROOT, 'transacciones')
const pc = createPrefixer(ROOT, 'configuracion')
const pi = createPrefixer(ROOT, 'informes')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_COMPRAS,
    dashboard: {
        _perm: rp('dashboard'),
    },
    mantenimiento: {
        _perm: rp('mantenimiento'),
        categoriasServicio: pm('categorias-servicio'),
        creacionPlantillaSolicitud: pm('creacion-plantilla-solicitud'),
        jefeArea: pm('jefe-area'),
        lineasServicio: pm('lineas-servicio'),
        plantillasSolicitud: pm('plantillas-solicitud'),
        servicios: pm('servicio'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        aprobacionContableServicios: pc('aprobacion-contable-servicios'),
        aprobacionTributariaServicios: pc('aprobacion-tributaria-servicios'),
        duenoCategoria: pc('dueno-categoria'),
        nivelAprobacionSolicitud: pc('nivel-aprobacion-solicitud'),
        permisoCategoria: pc('permiso-categoria'),
        responsablesAprobacionOC: pc('responsables-aprobacion-oc'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        solicitudesCompra: {
            _perm: pt('solicitudes-compra'),
            aprobacionSolicitud: pt('aprobacion-solicitud'),
            aprobacionSolicitudCategoria: pt('aprobacion-solicitud-categoria'),
            creacionSolicitud: pt('crear-solicitud'),
            gestionPublicacionesSolicitud: pt('gestion-publicaciones-solicitud'),
            gestionSolicitudes: pt('gestion-solicitudes'),
        },
        cotizaciones: {
            _perm: pt('cotizaciones'),
            creacionCotizacion: pt('crear-cotizacion'),
            seleccionCotizaciones: pt('seleccion-cotizaciones'),
            gestionCotizaciones: pt('gestion-cotizaciones'),
        },
        ordenesCompra: {
            _perm: pt('ordenes-compra'),
            aprobacionOC: pt('aprobacion-orden-compra'),
            creacionOrdenCompra: pt('crear-orden-compra'),
            gestionOrdenCompra: pt('gestion-ordenes-compra'),
        },
        ordenesEntrega: {
            _perm: pt('ordenes-entrega'),
            creacionOrdenEntrega: pt('crear-orden-entrega'),
            gestionOrdenEntrega: pt('gestion-ordenes-entrega'),
            recepcionOrdenEntregaBien: pt('recepcion-orden-entrega-bien'),
            recepcionOrdenEntregaServicio: pt('recepcion-orden-entrega-servicio'),
            revisionRecepcionOrdenEntrega: pt('revision-recepcion-orden-entrega'),
        },
    },
    informes: {
        _perm: rp('informes'),
        cotizaciones: pi('cotizaciones'),
        costosCotizaciones: pi('costos-cotizaciones'),
        historialPrecios: pi('historial-precios'),
        itemXOrdenesCompra: pi('item-x-ordenes-compra'),
        ordenesCompraVsRecepcionBodega: pi('ordenes-compra-vs-recepcion-bodega'),
        ordenesCompraXStatus: pi('ordenes-compra-x-status'),
        ordenesEntregaXStatus: pi('ordenes-entrega-x-status'),
        recepcionesOrdenEntrega: pi('recepciones-orden-entrega'),
        seguimientoSolicitudes: pi('seguimiento-solicitudes'),
        solicitudesXItem: pi('solicitudes-x-item'),
        solicitudesXStatus: pi('solicitudes-x-status'),
    },
}
export default permission
